export default {
  breadcrumbs: {
    list: '証明書管理',
    edit: '証明書変更',
    register: '証明書登録',
  },
  label: {
    device_code: '端末管理番号',
    device_name: '端末名',
    company_name: '提携企業名',
    store_name: '提携店名',
    release_date: '証明書発行日',
    expire_date: '証明書有効期限',
    download: '証明書ダウンロード',
    note: '備考',
    downloaded: '済',
    not_download: '未処理',
    download_success: '証明書のダウンロードが完了致しました。',
    copy: 'コピー',
    enter_device_code: 'ダウンロードするには端末管理番号を入力してください',
  },
  button: {
    register: '証明書登録',
    partner_store_select: '提携店選択',
    download: 'ダウンロード',
  },
  table: {
    device_code: '端末管理番号',
    device_name: '端末名',
    company_name: '提携企業名',
    store_name: '提携店名',
    release_date: '証明書発行日',
    expire_date: '証明書有効期限',
    download: '証明書インストール',
  },
  modal: {
    delete: {
      message: 'こちらの証明書を削除してもよろしいですか。',
    },
    download: {
      title: 'ダウンロードの確認',
      message: 'こちらのバーコードをダウンロードしてもよろしいですか。',
    },
  },
};
